export const ADVANCED_SEARCH_SINGLE_SELECT_PREFIX = 'advanced-search-builder-select';
